import React from 'react';
import Slider from './slider';
import Direction from './direction';
import ColorPicker from './colorPicker';
import Code from './code';
import Text from './text';
import Style from './style.sass';

export default class Triangle extends React.Component {

  constructor(props) {
    
    super(props); 

    this.state = {
      class: 'triangle',
      width: 100,
      height: 100,
      color: '#65e297',
      direction: 'top',
    }
  }

  componentDidMount() {
    const triangle = document.getElementById('triangle');
    triangle.style.background = `linear-gradient(to bottom left, transparent 50%,${this.state.color} 51%) no-repeat top right/50% 100%, linear-gradient(to bottom right, transparent 50%, ${this.state.color} 51%) no-repeat bottom left/50% 100%`;
  }

  componentDidUpdate() {
    const triangle = document.getElementById('triangle');
    switch (this.state.direction) {
      case 'top':
        triangle.style.background = `linear-gradient(to bottom left, transparent 50%,${this.state.color} 51%) no-repeat top right/50% 100%, linear-gradient(to bottom right, transparent 50%, ${this.state.color} 51%) no-repeat bottom left/50% 100%`;
        break;
      case 'topRight':
        triangle.style.background = `linear-gradient(to top right, transparent 50%,${this.state.color} 51%)`;
        break;
      case 'right':
        triangle.style.background = `linear-gradient(to bottom left, transparent 50%,${this.state.color} 51%) no-repeat top right/100% 50%, linear-gradient(to top left, transparent 50%, ${this.state.color} 51%) no-repeat bottom left/100% 50%`;
        break;
      case 'bottom':
        triangle.style.background = `linear-gradient(to top left, transparent 50%,${this.state.color} 51%) no-repeat top right/50% 100%, linear-gradient(to top right, transparent 50%, ${this.state.color} 51%) no-repeat bottom left/50% 100%`;
        break;
      case 'bottomRight':
        triangle.style.background = `linear-gradient(to bottom right, transparent 50%,${this.state.color} 51%)`;
        break;
      case 'bottomLeft':
        triangle.style.background = `linear-gradient(to bottom left, transparent 50%,${this.state.color} 51%)`;
        break;
      case 'left':
        triangle.style.background = `linear-gradient(to bottom right, transparent 50%,${this.state.color} 51%) no-repeat top right/100% 50%, linear-gradient(to top right, transparent 50%, ${this.state.color} 51%) no-repeat bottom left/100% 50%`;
        break;
      case 'topLeft':
        triangle.style.background = `linear-gradient(to top left, transparent 50%,${this.state.color} 51%)`;
        break;
    }
  }

  handleChangeText = e => {
    this.setState({
      class: e.target.value,
    })
  }

  handleChangeWidth = e => {
    this.setState({
      width: e.target.value,
    })
    const triangle = document.getElementById('triangle');
    triangle.style.width = e.target.value + 'px'
  }

  handleChangeHeight = e => {
    this.setState({
      height: e.target.value,
    })
    const triangle = document.getElementById('triangle');
    triangle.style.height = e.target.value + 'px'
  }

  handleChangeDirection = e => {
    this.setState({
      direction: e.target.dataset.direction,
    })
  }

  handleChangeColor = e => {
    this.setState({
      color: e.target.value,
    })
  }

  copyAllText = e => {
    e.target.select();
  }

  render() {

    const htmlCode = `<div class='${this.state.class}'></div>`
    const cssCode = `.${this.state.class} {\n  width: ${this.state.width}px;\n  height: ${this.state.height}px;\n  background: linear-gradient(to bottom left, transparent 50%,${this.state.color} 51%) no-repeat top left/100% 50%, linear-gradient(to top left, transparent 50%, ${this.state.color} 51%) no-repeat bottom left/100% 50%;\n}`
    return (
      <div className={Style.Triangle}>
        <section>
          <h1 className={Style.Triangle__heading}>CSS三角形ジェネレーター</h1>
          <div className='c-info u-mt-15 u-fs-s'>CSSで三角形を生成できます。</div>
        </section>
        <section className={Style.Triangle__generater}>
          <div className={Style.Triangle__controller}>
            <Text className={Style.Triangle__className} label='クラス名' value={this.state.class} onChange={e => this.handleChangeText(e)}/>
            <Direction onClick={e => this.handleChangeDirection(e)} direction={this.state.direction}/>
            <ColorPicker value={this.state.color} onChange={e => this.handleChangeColor(e)}/>
            <Slider label='幅' value={this.state.width} onChange={e => this.handleChangeWidth(e)}/>
            <Slider label='高さ' value={this.state.height} onChange={e => this.handleChangeHeight(e)}/>
          </div>
          <section className={Style.Triangle__view}>
            <div className={Style.Triangle__output}>
              <div className={Style.Triangle__object} id='triangle'></div>
            </div>
            <Code class={this.state.class} html={htmlCode} css={cssCode} onClick={e => this.copyAllText(e)}/>
          </section>
        </section>
      </div>
    )
  }
}